import './header';
import './single';
import './swiper';
import './dropdown-fascicles';
import './featured-articles';
import './modal.js';
import './navigation-tabs';
import './custom-select';
import './IndexContent';
import './faq';
import './backToTopButton.js';
import './ModalMagazine';
